(() => {
  const day = new Intl.DateTimeFormat('en-GB', {
    timeZone: 'Europe/Paris', year: 'numeric', month: '2-digit', day: '2-digit'
  });
  const month = new Intl.DateTimeFormat('fr-FR', { timeZone: 'UTC', month: 'long' });
  const weekday = new Intl.DateTimeFormat('fr-FR', { timeZone: 'UTC', weekday: 'long' });

  function estimate() {
    const parts = Object.fromEntries(day.formatToParts(new Date()).map(({ type, value }) => [type, value]));
    const today = Date.UTC(Number(parts.year), Number(parts.month) - 1, Number(parts.day), 12);
    const first = new Date(today + 4 * 86400000);
    const last = new Date(today + 7 * 86400000);
    const firstMonth = month.format(first);
    const lastMonth = month.format(last);
    const from = first.getUTCDate();
    const to = last.getUTCDate();
    const sameMonth = firstMonth === lastMonth && first.getUTCFullYear() === last.getUTCFullYear();
    return {
      first: `${weekday.format(first)} ${from}${sameMonth ? '' : ` ${firstMonth}`}`,
      last: `${weekday.format(last)} ${to} ${lastMonth}`
    };
  }

  function render() {
    document.querySelectorAll('.lv-pdp-shell [class$="offer__pay"]').forEach((badges) => {
      let line = badges.nextElementSibling;
      if (!line || !line.classList.contains('lv-delivery-estimate')) {
        line = document.createElement('p');
        line.className = 'lv-delivery-estimate';
        badges.insertAdjacentElement('afterend', line);
      }
      if (!line.querySelector('.lv-delivery-estimate__range')) {
        line.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M2 6h12v11H2zM14 9h4l4 4v4h-8z"/><circle cx="6" cy="18" r="2"/><circle cx="18" cy="18" r="2"/></svg><span class="lv-delivery-estimate__copy">Livraison estimée : 4 à 7 jours.</span>';
      }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', render, { once: true });
  else render();
  document.addEventListener('shopify:section:load', render);
  setInterval(render, 300000);
})();
